import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-content-loading',
  templateUrl: './content-loading.component.html',
  styleUrls: ['./content-loading.component.scss']
})
export class ContentLoadingComponent {

}
